import { IHinhThucTinh } from "../../../model/respone/mien-giam/IHinhThucTinh";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eHinhThucTinhActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IHinhThucTinh[],
  LOAD_ERRR: "",
};
export const eHinhThucTinhActionIds = generateActionTypeIds(
  eHinhThucTinhActionsObj,
  "HINH_THUC_TINH_MIEN_GIAM"
);
export type IHinhThucTinhActionTypes = IGenericActionType<
  typeof eHinhThucTinhActionsObj,
  "HINH_THUC_TINH_MIEN_GIAM"
>;
